export default {
  name: 'misc.situation',
  key: 'situation',
  attributes: {
    research: {
      key: 'research',
      name: 'entity.researchBase.situation.research',
    },
    immoral: {
      key: 'immoral',
      name: 'entity.researchBase.situation.immoral',
    },
    outsiders: {
      key: 'outsiders',
      name: 'entity.researchBase.situation.outsiders',
    },
    monsters: {
      key: 'monsters',
      name: 'entity.researchBase.situation.monsters',
    },
    tech: {
      key: 'tech',
      name: 'entity.researchBase.situation.tech',
    },
  },
};
